import GoalsReview from "./goals/review/GoalsReview";
import GoalsBoardPage from "./goals/BoardPage";
import ProjectsBoardPage from "./projects/BoardPage";
import WorkBoardPage from "./work/BoardPage";
import BreakageReview from "./breakage/review/BreakageReview";
import BreakageClientPage from "./breakage/BreakageClientPage";
import BreakageBoardPage from "./breakage/BoardPage";
import HomePage from "./home/HomePage";
import EmailBoardPage from "./email/BoardPage";
import EmailZeroWallPage from "./email/ZeroWallPage";
import CalendarBoardPage from "./calendar/BoardPage";
import CitiesBoardPage from "./cities/BoardPage";
import PeopleBoardPage from "./people/BoardPage";
import NeedsMePage from "./needsme/NeedsMePage";
import InFlightPage from "./inflight/InFlightPage";
import StatusPage from "./status/StatusPage";
import DocsPage from "./docs/DocsPage";
import MusicPage from "./music/MusicPage";
import ChatPage from "./chat/ChatPage";
// BrandsBoardPage import removed 10/21 (Brands board page dropped — Jeff).
// CalendarBoardPage stays imported: brand-scoped routes /{brand}/calendar still
// mount it directly in App.js (the consolidated Schedule page embeds it bare).

// Each screen plugs in here: its review page at `path`, its bare screen at `${path}/board`. Only built screens are listed.
// Consolidated: Calendar is a tab on the Schedule page (Jeff 2026-10-21),
// /calendar redirects to /schedule?tab=calendar (App.js). Brands board removed
// (Jeff 2026-10-21) — brand overviews (/tjb, /to, …) are separate and stay.
//
// 4→2 consolidation, phase 1 (council 2026-10-22): the two composite pages
// exist and are routed. The nav flip and the old-path redirects come later —
// the Desk, Work, Projects, and Breakage pages stay routed and working.
export const SCREENS = [
  // /status has no nav entry (the band links to it) — Review+Bare are the same page.
  {
    key: "status",
    label: "Status",
    path: "/status",
    Review: StatusPage,
    Bare: StatusPage,
  },

  {
    key: "goals",
    label: "Goal Board",
    path: "/goals",
    Review: GoalsReview,
    Bare: GoalsBoardPage,
  },
  {
    key: "breakage",
    label: "Breakage Board",
    path: "/breakage",
    Review: BreakageClientPage,
    Bare: BreakageBoardPage,
  },
  {
    key: "projects",
    label: "Projects",
    path: "/projects",
    Review: ProjectsBoardPage,
    Bare: ProjectsBoardPage,
  },
  {
    key: "work",
    label: "Work",
    path: "/work",
    Review: WorkBoardPage,
    Bare: WorkBoardPage,
  }, // P2/P3: the goal-axis page; the review shell never existed for it
  {
    key: "needsme",
    label: "Needs Me",
    path: "/needsme",
    Review: NeedsMePage,
    Bare: NeedsMePage,
  },
  {
    key: "inflight",
    label: "In Flight",
    path: "/inflight",
    Review: InFlightPage,
    Bare: InFlightPage,
  },
  // /email is the mail client; /email/board is the zero-inbox wall — the count
  // Jeff trusts (headline, brand tiles, the unsorted tile, the burst line, the
  // parked count, and the stamp). The wall's numbers are verified by the
  // differential gate before they ever reach this file.
  {
    key: "email",
    label: "Email",
    path: "/email",
    Review: EmailBoardPage,
    Bare: EmailZeroWallPage,
  },
  {
    key: "cities",
    label: "Cities",
    path: "/tjb/cities",
    Review: CitiesBoardPage,
    Bare: CitiesBoardPage,
  },
  {
    key: "people",
    label: "People",
    path: "/people",
    Review: PeopleBoardPage,
    Bare: PeopleBoardPage,
  },
  // The music library (phase 2-3): the daily set as a board, three playlists
  // cut from it, and the player bar that lives in the app shell above the
  // routing. Review and Bare are the same page — the library IS the page.
  {
    key: "chat",
    label: "Chat",
    path: "/chat",
    Review: ChatPage,
    Bare: ChatPage,
  },
  {
    key: "music",
    label: "Music",
    path: "/music",
    Review: MusicPage,
    Bare: MusicPage,
  },
];
